import Layout from '@/components/layout';
import { config } from '@/config';
import { PricingPlan } from '@/constants/enum';
import { isAvailableFeature } from '@/helpers';
import { useGetWidgetAppearanceTextQuery } from '@/redux/query';
import { shopInfoSelector } from '@/redux/slice/shop.slice';
import {
  handleSaveWidgetTextPaginationSettings,
  handleSaveWidgetTextTableSettings,
  handleSetWidgetTextDisable,
  widgetTextPaginationSettingSelector,
} from '@/redux/slice/widgetText.slice';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ManageLanguage from './component/ManageLanguage';
import { SkeletonWrapper } from '@/components/SkeletonLayout/styled';
import SkeletonLayout from '@/components/SkeletonLayout';
import useTitleBar from '@/hooks/useTitleBar';

const Translation = () => {
  const { t } = useTranslation('translation');
  const widgetTextPaginationSetting = useSelector(widgetTextPaginationSettingSelector);
  const shopInfo = useSelector(shopInfoSelector);
  const {
    data: widgetAppearanceText,
    isFetching: isFetchingWidgetText,
    isLoading: isLoadingWidgetText,
  } = useGetWidgetAppearanceTextQuery({
    shop: config.shop,
    offset: (widgetTextPaginationSetting.page - 1) * widgetTextPaginationSetting.perPage,
    limit: widgetTextPaginationSetting.perPage,
  });

  const { data: fullWidgetAppearanceText } = useGetWidgetAppearanceTextQuery({
    shop: config.shop,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(handleSaveWidgetTextTableSettings(widgetAppearanceText?.data.appearanceText || []));
    dispatch(
      handleSaveWidgetTextPaginationSettings({
        hasNext: widgetAppearanceText?.data.hasNextPage,
        hasPrevious: widgetAppearanceText?.data.hasPreviousPage,
      }),
    );
  }, [dispatch, fullWidgetAppearanceText?.data.appearanceText, widgetAppearanceText?.data]);

  useEffect(() => {
    dispatch(
      handleSetWidgetTextDisable({
        isDisableManageLanguage: !isAvailableFeature(PricingPlan.Smart, shopInfo.plan as PricingPlan),
      }),
    );
  }, [dispatch, shopInfo.plan]);

  useTitleBar({ title: t('page.title') });

  return (
    <Layout>
      {isLoadingWidgetText ? (
        <SkeletonWrapper>
          <SkeletonLayout elementCount={1} />
        </SkeletonWrapper>
      ) : (
        <ManageLanguage
          isLoadingTranslationTable={isFetchingWidgetText}
          fullWidgetAppearanceText={fullWidgetAppearanceText?.data.appearanceText}
        />
      )}
    </Layout>
  );
};

export default Translation;
